"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.directionMap = exports.IS_RTL_PARAM = void 0;
exports.IS_RTL_PARAM = '__IS_RTL__';
exports.directionMap = {
    'ALIGNMENT-START': { ltr: 'start', rtl: 'end' },
    'ALIGNMENT-END': { ltr: 'end', rtl: 'start' },
    START: { ltr: 'left', rtl: 'right' },
    END: { ltr: 'right', rtl: 'left' },
    STARTSIGN: { ltr: '-', rtl: '' },
    ENDSIGN: { ltr: '', rtl: '-' },
    'DEG-START': { ltr: '0', rtl: '180' },
    'DEG-END': { ltr: '180', rtl: '0' },
    DIR: { ltr: 'ltr', rtl: 'rtl' },
};
//# sourceMappingURL=constants.js.map